import { TkCsvValidateProps } from "../../../type/componentsType/TkCsvUpload";

const MaxErrorNum = 100;

const MIN_SALARY_AMT = 1;

const MAX_SALARY_AMT = 999999999;

const headList = [
  {
    headTitle: "No.",
  },
  {
    headTitle: "行目",
  },
  {
    headTitle: "項目名",
  },
  {
    headTitle: "メッセージID",
  },
  {
    headTitle: "メッセージ内容",
  },
];

const headListBank = [
  {
    headTitle: "No.",
  },
  {
    headTitle: "行目",
  },
  {
    headTitle: "メッセージID",
  },
  {
    headTitle: "メッセージ内容",
  },
];

const headListBefore = [
  {
    headTitle: "No.",
  },
  {
    headTitle: "メッセージID",
  },
  {
    headTitle: "メッセージ内容",
  },
];

const houjinStaffInfoValidate: TkCsvValidateProps[] = [
  {
    index: 0,
    name: "facilityName",
    fieldName: "施設名",
    must: true,
    min: null,
    max: 85,
    format: "text",
    canBeHalfWidth: true,
    canBeFullWidth: true,
  },
  {
    index: 1,
    name: "staffLastNameHalfKana",
    fieldName: "職員名 姓（半角ﾌﾘｶﾞﾅ）",
    must: false,
    min: null,
    max: 30,
    format: "text",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 2,
    name: "staffFirstNameHalfKana",
    fieldName: "職員名 名（半角ﾌﾘｶﾞﾅ）",
    must: false,
    min: null,
    max: 30,
    format: "text",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 3,
    name: "staffLastName",
    fieldName: "職員名 姓",
    must: true,
    min: null,
    max: 30,
    format: "text",
    canBeHalfWidth: false,
    canBeFullWidth: true,
  },
  {
    index: 4,
    name: "staffFirstName",
    fieldName: "職員名 名",
    must: true,
    min: null,
    max: 30,
    format: "text",
    canBeHalfWidth: false,
    canBeFullWidth: true,
  },
  {
    index: 5,
    name: "birthDate",
    fieldName: "生年月日",
    must: true,
    min: 8,
    max: 8,
    format: "date",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 6,
    name: "gender",
    fieldName: "性別",
    must: true,
    min: 1,
    max: 1,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
    otherRule: /^[129]$/,
  },
  {
    index: 7,
    name: "membershipQualification",
    fieldName: "加入資格",
    must: true,
    min: 1,
    max: 2,
    format: "text",
    canBeHalfWidth: false,
    canBeFullWidth: true,
    otherRule: /^(ア|イ|ウ|不明)$/,
  },
  {
    index: 8,
    name: "jobType",
    fieldName: "職種",
    must: true,
    min: 2,
    max: 2,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 9,
    name: "salaryScaleAmount",
    fieldName: "俸給表の額",
    must: true,
    min: null,
    max: null,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 10,
    name: "salaryAdjustmentAmount",
    fieldName: "俸給の調整額",
    must: true,
    min: null,
    max: null,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 11,
    name: "hasBeenMutualAidStaff",
    fieldName: "被共済職員であったことの有無",
    must: true,
    min: 1,
    max: 1,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
    otherRule: /^[01]$/,
  },
  {
    index: 12,
    name: "reasonForNotBeingMutualAidStaff",
    fieldName: "被共済職員でなくなった理由",
    must: false,
    min: 1,
    max: 1,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
    otherRule: /^[1-3]$/,
  },
  {
    index: 13,
    name: "dateOfNoLongerBeingMutualAidStaff",
    fieldName: "被共済職員でなくなった年月日",
    must: false,
    min: 8,
    max: 8,
    format: "date",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 14,
    name: "previousMutualAidContractorName",
    fieldName: "前共済契約者名",
    must: false,
    min: null,
    max: 60,
    format: "text",
    canBeHalfWidth: false,
    canBeFullWidth: true,
  },
  {
    index: 15,
    name: "previousMutualAidContractorNumber",
    fieldName: "前共済契約者番号",
    must: false,
    min: 6,
    max: 6,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 16,
    name: "previousStaffNumber",
    fieldName: "前職員番号",
    must: false,
    min: 5,
    max: 5,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
];

const houjinStaffMonthlySalaryValidate: TkCsvValidateProps[] = [
  {
    index: 0,
    name: "staffNumber",
    fieldName: "職員番号",
    must: true,
    min: 5,
    max: 5,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 1,
    name: "year",
    fieldName: "年度",
    must: true,
    min: 4,
    max: 4,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 2,
    name: "salary",
    fieldName: "俸給表の額",
    must: true,
    min: null,
    max: null,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 3,
    name: "salaryAdjustment",
    fieldName: "俸給の調整額",
    must: true,
    min: null,
    max: null,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
];

const transferResultValidate: TkCsvValidateProps[] = [
  {
    index: 0,
    name: "bankNumber",
    fieldName: "被仕向銀行番号",
    must: true,
    min: 4,
    max: 4,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 1,
    name: "bankName",
    fieldName: "被仕向銀行名",
    must: true,
    min: 15,
    max: 15,
    format: "text",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 2,
    name: "branchNumber",
    fieldName: "被仕向支店番号",
    must: true,
    min: 3,
    max: 3,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 3,
    name: "branchName",
    fieldName: "被仕向支店名",
    must: true,
    min: 15,
    max: 15,
    format: "text",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 4,
    name: "depositType",
    fieldName: "預金種目",
    must: true,
    min: 1,
    max: 1,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
    otherRule: /^[129]$/,
  },
  {
    index: 5,
    name: "accountNumber",
    fieldName: "口座番号",
    must: true,
    min: 7,
    max: 7,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 6,
    name: "recipientName",
    fieldName: "受取人名",
    must: true,
    min: 30,
    max: 30,
    format: "text",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 7,
    name: "transferAmount",
    fieldName: "振込金額",
    must: true,
    min: 10,
    max: 10,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
  },
  {
    index: 8,
    name: "unreceivedReason",
    fieldName: "不着事由",
    must: true,
    min: 1,
    max: 1,
    format: "number",
    canBeHalfWidth: true,
    canBeFullWidth: false,
    otherRule: /^[123456789]$/,
  },
];

export {
  MaxErrorNum,
  MIN_SALARY_AMT,
  MAX_SALARY_AMT,
  headList,
  headListBank,
  headListBefore,
  houjinStaffInfoValidate,
  houjinStaffMonthlySalaryValidate,
  transferResultValidate,
};
